/* eslint-disable import/prefer-default-export */

/**
 * ページのパス名
 */
export const PAGE_PATH_NAME = {
  // シリアル入力画面
  SERIAL_INPUT: '/',
  // トレーニング選択画面
  LESSON: '/lesson',
  // トレーニング画面
  TRAINING: '/training',
} as const;

/**
 * センテンス表示開始時間の修正時間（秒）
 * - iOS
 * currentTimeを直接変更すると、必ず「0.25秒」ほど（戻される時間は、毎回違う）再生時間が戻ってしまう。
 * そのため、センテンスの表示を早めて、センテンスが消えて再度表示されるのを防ぐために、表示時間を早める
 *
 * - Safari(macOS)
 * currentTimeを変更すると若干巻き戻される。こちらもiOSと同様に、表示を早めるようにする。
 *
 * - その他
 * 他のブラウザは問題ないが、全てのブラウザで処理を統一するため同様に表示を早める
 */
export const FIX_SENTENCE_START_TIME = 0.3;

/**
 * トピックのセンテンスID
 */
export const TOPIC_SENTENCE_ID = '0-1';
